import { InputNumber } from "antd";
import styled from "styled-components";
import { EFeeType } from "../../types/masterFee.type";
import InputPrice from "./InputPrice";

interface InputPercentOrAmoutProps {
	inputFormat?: EFeeType;
	value?: string;
	onChange?: (value?: string | number) => void;
	placeholder?: string;
	disabled?: boolean;
	readOnly?: boolean;
	addonBefore?: string;
	addonAfter?: any;
	onClick?: () => void;
}

const InputPercentOrAmout: React.FC<InputPercentOrAmoutProps> = ({
	inputFormat,
	value,
	onChange,
	placeholder,
	disabled,
	readOnly,
	addonBefore,
	addonAfter,
	onClick,
	...rest
}) => {
	const _handleChange = (v?: string | number | null) => {
		// const newValue = typeof v === "number" ? v.toString() : typeof v === "string" ? v : undefined;

		const newValue =
			typeof v === "number"
				? v.toFixed(2) // Round to 2 decimal places
				: typeof v === "string"
				? parseFloat(v).toFixed(2) // Round to 2 decimal places
				: undefined;

		// Check for consecutive dots in the input
		onChange?.(
			newValue && !isNaN(parseFloat(newValue)) && isFinite(parseFloat(newValue)) ? Number(newValue) : undefined
		);
	};

	const _handleChangeAmount = (v?: string | number | null) => {
		const newValue = typeof v === "number" ? v.toString() : typeof v === "string" ? v : undefined;

		onChange?.(
			newValue && !isNaN(parseFloat(newValue)) && isFinite(parseFloat(newValue)) ? Number(newValue) : undefined
		);
	};

	return inputFormat === EFeeType.AMOUNT ? (
		<InputPrice
			onChange={_handleChangeAmount}
			value={value}
			{...rest}
			readOnly={readOnly}
			disabled={disabled}
			placeholder={placeholder}
			addonBefore={addonBefore}
			addonAfter={addonAfter}
			onClick={onClick}
		/>
	) : (
		<StyledInputNumber
			addonAfter={addonAfter ? addonAfter : inputFormat === EFeeType.PERCENTAGE ? "%" : undefined}
			onChange={(v) => _handleChange(v)}
			value={value}
			controls={false}
			step={0.01} // Set step to 0.01 for two decimal places
			formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")} // Add commas for better readability
			{...rest}
			onKeyPress={(event) => {
				if (event.key.includes(",") || !/^[0-9.]+$/.test(event.key)) {
					event.preventDefault();
				}
			}}
			max={100}
			readOnly={readOnly}
			disabled={disabled}
			placeholder={placeholder}
			addonBefore={addonBefore}
			onClick={onClick}
		/>
	);
};

const StyledInputNumber = styled(InputNumber)`
	.ant-input-number.ant-input-number-in-form-item {
		border-right: none;
	}
	.ant-input-number.ant-input-number-in-form-item:hover + .ant-input-number-group-addon {
		border: 1px solid rgba(0, 0, 0, 0.85);
		border-left: none;
	}
	:not(.ant-input-number-disabled) + .ant-input-number-group-addon {
		background: white;
	}
	.ant-input-number-focused + .ant-input-number-group-addon {
		border: 1px solid rgba(0, 0, 0, 0.85);
		border-left: none;
	}
	.ant-input-number.ant-input-number-in-form-item.ant-input-number-status-error + .ant-input-number-group-addon {
		border-color: #ff7875;
		border-left: none;
	}
	.ant-input-number-group-addon {
		z-index: 2;
	}
	width: 100%;
`;

export default InputPercentOrAmout;
